import actions from './actions';

export default {
  toggleSkinnyNav: actions.toggleSkinnyNav,
  toggleDrawer: actions.toggleDrawer,
};
